import React, { useState } from 'react';
import { 
  Button, 
  Input, 
  Card, 
  Row, 
  Col, 
  Table, 
  Typography, 
  Space,
  message
} from 'antd';
import { SearchOutlined, DatabaseOutlined } from '@ant-design/icons';
import API from '../services/api'; // 导入统一的API实例

const { Title } = Typography;

const ConnectionQuery = () => {
  const [ip, setIp] = useState('');
  const [inputData, setInputData] = useState(null);



  // 查询单个IP输入包数数据
  const handleIpConnectionQuery = async () => {
    if (!ip.trim()) {
      message.warning('请输入IP地址');
      return;
    }
    
    try {
      const response = await API.get(`/api/admin/connections/${ip}`);
      if (!response.data.inputData) {
        message.info('暂无数据');
        setInputData(null);
      } else {
        setInputData(response.data.inputData); // 获取的输入包数和流量数据
        message.success('查询成功');
      }
    } catch (error) {
      console.error('获取单个IP连接数失败:', error);
      message.error('获取单个IP连接数失败');
      setInputData(null);
    }
  };

  // 将字节流量转换为 Mbps
  const convertToMbps = (size) => {
    return (size / (1000 * 128)).toFixed(2); // 直接转换为 Mbps
  };

  // 渲染输入表格数据
  const renderInputTable = () => {
    if (!inputData) return null;

    const inputColumns = [
      {
        title: '序号',
        key: 'index',
        align: 'center',
        width: 50,
        render: () => 1,
      },
      {
        title: '主机',
        key: 'host',
        align: 'center',
        width: 100,
        render: () => inputData.host,
      },
      {
        title: '输入包数(pps)',
        key: 'in_packets',
        align: 'center',
        width: 90,
        render: () => inputData.in_packets,
      },
      {
        title: '输入流量(Mbps)',
        key: 'in_size',
        align: 'center',
        width: 100,
        render: () => convertToMbps(inputData.in_size),
      },
      {
        title: '拦截流量(Mbps)',
        key: 'in_drop_size',
        align: 'center',
        width: 110,
        render: () => convertToMbps(inputData.in_drop_size),
      },
      {
        title: 'UDP',
        key: 'udp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.udp_packets,
      },
      {
        title: 'ICMP',
        key: 'icmp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.icmp_packets,
      },
      {
        title: 'TCP',
        key: 'tcp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.tcp_packets,
      },
      {
        title: '其他',
        key: 'other_packets',
        align: 'center',
        width: 60,
        render: () => inputData.other_packets,
      },
    ];

    return (
      <Card 
        title={
          <span style={{ color: '#1890ff' }}>
            <DatabaseOutlined style={{ marginRight: 8 }} />
            输入数据
          </span>
        }
        style={{ marginBottom: 24 }}
      >
        <Table
          columns={inputColumns}
          dataSource={[{ key: '1' }]}
          pagination={false}
          bordered
          size="small"
          scroll={{ x: 600 }}
        />
      </Card>
    );
  };

  // 渲染输出表格数据
  const renderOutputTable = () => {
    if (!inputData) return null;

    const outputColumns = [
      {
        title: '序号',
        key: 'index',
        align: 'center',
        width: 50,
        render: () => 1,
      },
      {
        title: '主机',
        key: 'host',
        align: 'center',
        width: 100,
        render: () => inputData.host,
      },
      {
        title: '输出包数(pps)',
        key: 'out_packets',
        align: 'center',
        width: 90,
        render: () => inputData.out_packets,
      },
      {
        title: '输出流量(Mbps)',
        key: 'out_size',
        align: 'center',
        width: 100,
        render: () => convertToMbps(inputData.out_size),
      },
      {
        title: '拦截流量(Mbps)',
        key: 'out_drop_size',
        align: 'center',
        width: 110,
        render: () => convertToMbps(inputData.out_drop_size),
      },
      {
        title: 'UDP',
        key: 'udp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.udp_packets,
      },
      {
        title: 'ICMP',
        key: 'icmp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.icmp_packets,
      },
      {
        title: 'TCP',
        key: 'tcp_packets',
        align: 'center',
        width: 60,
        render: () => inputData.tcp_packets,
      },
      {
        title: '其他',
        key: 'other_packets',
        align: 'center',
        width: 60,
        render: () => inputData.other_packets,
      },
    ];

    return (
      <Card 
        title={
          <span style={{ color: '#52c41a' }}>
            <DatabaseOutlined style={{ marginRight: 8 }} />
            输出数据
          </span>
        }
        style={{ marginBottom: 24 }}
      >
        <Table
          columns={outputColumns}
          dataSource={[{ key: '1' }]}
          pagination={false}
          bordered
          size="small"
          scroll={{ x: 600 }}
        />
      </Card>
    );
  };

  return (
    <div style={{ padding: 24 }}>
      <Title level={2} style={{ textAlign: 'center', marginBottom: 32 }}>
        IP流量和连接数查询
      </Title>

      <Row justify="center" style={{ marginBottom: 32 }}>
        <Col xs={20} sm={16} md={12} lg={8}>
          <Card>
            <Space.Compact style={{ width: '100%' }}>
              <Input
                placeholder="输入IP地址"
                value={ip}
                onChange={(e) => setIp(e.target.value)}
                onPressEnter={handleIpConnectionQuery}
                prefix={<SearchOutlined />}
              />
              <Button 
                type="primary" 
                icon={<SearchOutlined />}
                onClick={handleIpConnectionQuery}
              >
                查询
              </Button>
            </Space.Compact>
          </Card>
        </Col>
      </Row>

      {/* 表格展示输入包数和流量数据 */}
      <Row>
        <Col span={24}>
          {renderInputTable()}
        </Col>
      </Row>

      {/* 表格展示输出包数和流量数据 */}
      <Row>
        <Col span={24}>
          {renderOutputTable()}
        </Col>
      </Row>
    </div>
  );
};

export default ConnectionQuery;
